// Formats a UTC timestamp for the dashboard's bar-chart x-axis in the
// currently selected timezone, matching the granularity requiredDateFormatForGraphXaxis
// picks for the active range (Current/Week/Month/Year). Scoped to the dashboard
// page only — src/utils/formatTime.js formatters remain browser-local for now.
const FORMAT_OPTIONS_BY_PATTERN = {
  "HH:mm": { hour: "2-digit", minute: "2-digit", hour12: false },
  EEE: { weekday: "short" },
  "dd MMM": { day: "2-digit", month: "short" },
  MMM: { month: "short" },
};

const formatIsoDateInTimezone = (date, timeZone) => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...(timeZone ? { timeZone } : {}),
  }).formatToParts(date);
  const get = (type) => parts.find((p) => p.type === type)?.value;
  return `${get("year")}-${get("month")}-${get("day")}`;
};

export const formatChartLabelInTimezone = (date, dateFormat, timeZone) => {
  if (dateFormat === "yyyy-MM-dd") {
    try {
      return formatIsoDateInTimezone(date, timeZone);
    } catch (error) {
      return formatIsoDateInTimezone(date);
    }
  }
  const options = FORMAT_OPTIONS_BY_PATTERN[dateFormat] || { day: "2-digit", month: "short" };
  try {
    return new Intl.DateTimeFormat("en-GB", { ...options, timeZone }).format(date);
  } catch (error) {
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  }
};
